import { useSecondaryMenu } from 'ui/components/BPLayout'

export const BatchSideBar = ({ type }: { type: string }) => {
  useSecondaryMenu([
    { label: 'General Information', hash: 'general' },
    { label: `${type === 'ctr' ? 'CTR' : 'SAR'}s in the Batch`, hash: `${type === 'ctr' ? 'ctrs' : 'sars'}` }
  ])

  return null
}
